import { number, object, string } from 'yup';

import { regExpLettersNumbersSpacesCommonPunctuation } from '@constants/regExp';
import { getLettersNumbersSpacesCommonPunctuationErrorMessage, getMaxLengthErrMsg, getMinLengthErrMsg, mandatoryErrMessage } from '@constants/validationConstants';
import { MAX_3_LENGTH, MAX_500_LENGTH } from '@constants/validationMessages';
import { EConfigurationTemplateValues } from './constants';

export const getSchema = (
	validateNameFn?: (value: string) => Promise<boolean>,
	checkNameError?: string,
	defaultName: string = '',
	isCloneMode: boolean = false,
) => object({
	[EConfigurationTemplateValues.name]: string()
		.trim()
		.required(mandatoryErrMessage('Name'))
		.test('name', checkNameError || getMinLengthErrMsg('Notes', MAX_3_LENGTH),
			async function (value) {
				if (!value || !validateNameFn || value === defaultName) {
					return isCloneMode ? false : true;
				}

				try {
					return await validateNameFn(value);
				} catch (error) {
					return false;
				}
			}),
	[EConfigurationTemplateValues.notes]: string()
		.trim()
		.test(
			EConfigurationTemplateValues.notes,
			getLettersNumbersSpacesCommonPunctuationErrorMessage('notes'),
			(value) => !value || regExpLettersNumbersSpacesCommonPunctuation.test(value),
		)
		.max(MAX_500_LENGTH, getMaxLengthErrMsg('Notes', MAX_500_LENGTH)),
	[EConfigurationTemplateValues.networkElement]: object()
		.nullable()
		.required(mandatoryErrMessage('Network Element')),
	[EConfigurationTemplateValues.type]: object()
		.nullable()
		.required(mandatoryErrMessage('Type')),
	[EConfigurationTemplateValues.date]: number()
		.required(mandatoryErrMessage('Date')),
	[EConfigurationTemplateValues.time]: object()
		.nullable()
		.required(mandatoryErrMessage('Time')),
});
